import { render, staticRenderFns } from "./quickStart.vue?vue&type=template&id=21d8a7be&scoped=true&"
import script from "./quickStart.vue?vue&type=script&lang=js&"
export * from "./quickStart.vue?vue&type=script&lang=js&"
import style0 from "./quickStart.vue?vue&type=style&index=0&id=21d8a7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8a7be",
  null
  
)

export default component.exports